import { type LoaderFunctionArgs, Outlet } from "react-router";
import { resolveLegacyRedirect } from "~/i18n/legacy-redirects.server";
import { isSupportedLocale } from "~/i18n/locales";
import { createUnsupportedLocaleRedirect } from "~/i18n/redirects.server";
import { resolveRequestLocale } from "~/i18n/resolve-locale.server";

const LOCALE_LIKE_SEGMENT_REGEX = /^[a-z]{2}(?:-[a-z]{2})?$/i;

export function loader({ params, request }: LoaderFunctionArgs) {
	const routeLocale = params.locale;

	if (routeLocale && isSupportedLocale(routeLocale)) {
		return null;
	}

	const legacyRedirect = resolveLegacyRedirect(request);
	if (legacyRedirect) {
		return legacyRedirect;
	}

	if (!(routeLocale && LOCALE_LIKE_SEGMENT_REGEX.test(routeLocale))) {
		throw new Response("Not Found", { status: 404 });
	}

	const fallbackLocale = resolveRequestLocale(request);
	return createUnsupportedLocaleRedirect(request, fallbackLocale);
}

export default function LocaleRoute() {
	return <Outlet />;
}
